import { Button } from "@/components/ui/button";
import routes from "@/utils/routes";
import type { AdminDetails } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import { FieldList, FieldRow, MissingRow, ProfileSection } from "../profilePrimitives";
import { adminMissing, adminRows } from "../profileRows";

export function AdminSection({
    memberId,
    admin,
    setOverlay,
}: {
    memberId: string;
    admin: AdminDetails;
    setOverlay: OpenProfileOverlay;
}) {
    return (
        <ProfileSection
            title="Admin"
            editable
            onEdit={() => setOverlay({ type: "edit", section: "admin" })}
        >
            <FieldList rows={adminRows(admin)} />
            {admin.themesPreview && (
                <FieldRow label="Themes">
                    <Button
                        variant="link"
                        className="h-auto p-0 text-xs"
                        render={
                            <a
                                href={routes.themesPreview(memberId)}
                                target="_blank"
                                rel="noreferrer"
                            />
                        }
                    >
                        Preview
                    </Button>
                </FieldRow>
            )}
            <FieldRow label="Calendar">
                {admin.calendarId ? (
                    <a
                        href={`https://calendar.google.com/calendar/u/0/embed?src=${encodeURIComponent(admin.calendarId)}&mode=AGENDA`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-xs text-zinc-900 leading-4 underline-offset-4 hover:underline"
                    >
                        View in new tab
                    </a>
                ) : (
                    <p className="text-xs text-zinc-500 leading-4">Not set</p>
                )}
            </FieldRow>
            {admin.philanthropy && (
                <FieldRow label="Philanthropy">
                    <div className="flex flex-col gap-0.5">
                        <p className="text-xs text-zinc-900 leading-4">
                            Climate: {admin.philanthropy.trees} trees
                        </p>
                        <p className="text-xs text-zinc-900 leading-4">
                            Oceans: {admin.philanthropy.kilograms} kg
                        </p>
                        <p className="text-xs text-zinc-900 leading-4">
                            Wildlife: {admin.philanthropy.squareMeters} m2
                        </p>
                    </div>
                </FieldRow>
            )}
            <MissingRow labels={adminMissing(admin)} />
        </ProfileSection>
    );
}
